module.exports = __webpack_public_path__ + "static/media/villains.d213761d.svg";